import React, { useEffect, useReducer, useRef, useState } from "react";
import { Link, useHistory } from "react-router-dom";
import "../shop/NewShopLanding.scss";
import {
  homepage,
  HttpStatus,
  LOGGIN,
  lstMarcas,
  SUCCESS_SERVER,
  localStoreEnum,
} from "../service/ENUM";
import { _IndentificadorMenu } from "../service/EnumMenu";
import { findProductosFilterInput } from "../service/producto.service";
import { handleSyncDatosCotizacion } from "../service/general";
import { obtenerCotizacionActiva } from "../service/cotizacion.service";

const actionType = {
  LOAD_FILTER: "LOAD_FILTER",
  DISPLAY_FILTER: "DISPLAY_FILTER",
  ERROR: "ERROR",
  CANTIDAD: "CANTIDAD",
};

const initialState = {
  displayFilter: false,
  listaFilter: [],
  server: { error: "", success: SUCCESS_SERVER.SUCCES_SERVER_DEFAULT },
  cantidad: 0,
};

const reducer = (state, action) => {
  switch (action.type) {
    case actionType.LOAD_FILTER:
      return {
        ...state,
        displayFilter: action.displayFilter,
        listaFilter: action.listaFilter,
      };
    case actionType.DISPLAY_FILTER:
      return {
        ...state,
        displayFilter: action.displayFilter,
      };
    case actionType.ERROR:
      return {
        ...state,
        server: action.server,
      };
    case actionType.CANTIDAD:
      return {
        ...state,
        cantidad: action.cantidad,
      };
    default:
      return state;
  }
};

const DEFAULT_BMW_LOGO = "https://upload.wikimedia.org/wikipedia/commons/4/44/BMW.svg";
const DEFAULT_MINI_LOGO = "https://upload.wikimedia.org/wikipedia/commons/thumb/e/e9/MINI_logo.svg/2560px-MINI_logo.svg.png";
const MOTRIX_LOGO = homepage ? `/${homepage}/marcas/eanet_motrix.svg` : "/marcas/eanet_motrix.svg";

function NewFilterMarcasHeader(props) {
  const timerRef = useRef();
  const history = useHistory();
  const [descripcion, setDescripcion] = useState(props.descripcion || "");
  const [state, dispatch] = useReducer(reducer, initialState);
  const [inLanding, setInLanding] = useState(false);
  const headerRef = useRef(null);
  const [brandOpen, setBrandOpen] = useState(false);
  const [isTouch, setIsTouch] = useState(false);

  const brandList = props.lstMarcas || lstMarcas;
  const isLogged = props.islogin === LOGGIN.LOGGIN;
  const marcaSelect = props.marcaSelect;
  const nombre = props.NombreCompleto || "";

  const brandOptions = (brandList || []).map((b) => {
    const name = (b.decripcion || b.descripcion || b.nombre || "").toLowerCase();
    const isMini = name.includes("mini");
    const isBmw = name.includes("bmw");
    const logoSrc = b.srcImage || (isMini ? DEFAULT_MINI_LOGO : DEFAULT_BMW_LOGO);
    return {
      key: b.codigoMarca || name || "brand",
      label: b.decripcion || b.descripcion || b.nombre || "Marca",
      logo: logoSrc,
      data: b,
    };
  });

  const currentBrandOption =
    brandOptions.find((opt) => opt.data?.codigoMarca === marcaSelect?.codigoMarca) || brandOptions[0];
  const isMiniSelected = (currentBrandOption?.label || "").toLowerCase().includes("mini");

  useEffect(() => {
    handleLoadCotizacionActiva();
    if (headerRef.current) {
      const wrapper = headerRef.current.closest(".nl-page");
      setInLanding(Boolean(wrapper));
    }
    const checkTouch = () => {
      if (typeof window === "undefined") return;
      const mq = window.matchMedia ? window.matchMedia("(hover: none) and (pointer: coarse)") : null;
      setIsTouch(Boolean(mq?.matches || "ontouchstart" in window));
      if (mq) {
        const handler = (evt) => setIsTouch(evt.matches);
        if (mq.addEventListener) mq.addEventListener("change", handler);
        else if (mq.addListener) mq.addListener(handler);
        return () => {
          if (mq.removeEventListener) mq.removeEventListener("change", handler);
          else if (mq.removeListener) mq.removeListener(handler);
        };
      }
      return undefined;
    };
    const cleanup = checkTouch();
    return () => {
      clearTimeout(timerRef.current);
      if (typeof cleanup === "function") cleanup();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.islogin, props.updateBottomCarrito]);

  const handleLoadCotizacionActiva = async () => {
    let cotizacionActiva = {
      numCodigoCotizacionOnline: 0,
      numCodigoClienteUsuario: 0,
      numCodigoCliente: 0,
      isLogin: 0,
    };
    if (localStorage.getItem(localStoreEnum.ISLOGIN) !== null) {
      const usuario = JSON.parse(localStorage.getItem(localStoreEnum.USUARIO));
      cotizacionActiva.numCodigoCliente = usuario.numCodigoCliente;
      cotizacionActiva.numCodigoClienteUsuario = usuario.numCodigoClienteUsuario;
      cotizacionActiva.isLogin = 1;
    } else {
      const cotizacion = handleSyncDatosCotizacion();
      cotizacionActiva.numCodigoCotizacionOnline = cotizacion.numCodigoCotizacionOnline;
      cotizacionActiva.isLogin = 0;
    }

    const rpt = await obtenerCotizacionActiva(cotizacionActiva);
    if (rpt.status === HttpStatus.HttpStatus_OK) {
      const json = await rpt.json();
      if (json.response.status === SUCCESS_SERVER.SUCCES_SERVER_OK) {
        dispatch({ type: actionType.CANTIDAD, cantidad: json.cantidad });
      }
      if (json.response.status === SUCCESS_SERVER.SUCCES_SERVER_INFO) {
        dispatch({
          type: actionType.ERROR,
          server: { error: json.response.error, success: SUCCESS_SERVER.SUCCES_SERVER_INFO },
        });
      }
    } else {
      dispatch({
        type: actionType.ERROR,
        server: { error: "", success: SUCCESS_SERVER.SUCCES_SERVER_ERROR },
      });
    }
  };

  const buildLogoSrc = () => {
    if (currentBrandOption?.logo) return currentBrandOption.logo;
    if (marcaSelect?.srcImage) return marcaSelect.srcImage;
    const descr = (marcaSelect?.descripcion || "").toLowerCase();
    if (descr.includes("mini")) return DEFAULT_MINI_LOGO;
    if (marcaSelect?.nombre?.toLowerCase().includes("mini")) return DEFAULT_MINI_LOGO;
    if (homepage !== null) {
      return `${window.location.origin}/${homepage}/marcas/logo.png`;
    }
    return `${window.location.origin}/marcas/logo.png`;
  };

  const onClickImage = () => {
    if (currentBrandOption?.data) {
      props.handleSelectMarcaChange(currentBrandOption.data.codigoMarca, "FilterMarcas");
      props.handleInputChangeDescripcion({ target: { value: "" } });
      setDescripcion("");
      history.push("/shop");
    }
  };

  const handleSelectBrand = (brandOption) => {
    if (!brandOption?.data) return;
    props.handleSelectMarcaChange(brandOption.data.codigoMarca, "FilterMarcas");
    props.handleInputChangeDescripcion({ target: { value: "" } });
    setDescripcion("");
    history.push("/shop");
    setBrandOpen(false);
  };

  const handleClickBuscarProductos = () => {
    props.handleInputChangeDescripcion({ target: { value: descripcion } });
    history.push(`/shop/${_IndentificadorMenu.Busqueda}/filter/${descripcion}`);
  };

  const handleInputChangeDescripcion = (e) => {
    const value = e.target.value;
    setDescripcion(value);
    handleFindListProducto(value.trim());
  };

  const handleOnKeyDown = (e) => {
    if (e.key === "Enter") {
      e.preventDefault();
      handleClickBuscarProductos();
    }
    if (e.key === "Escape") {
      props.handleInputChangeDescripcion({ target: { value: "" } });
      setDescripcion("");
      dispatch({
        type: actionType.LOAD_FILTER,
        displayFilter: false,
        listaFilter: [],
      });
    }
  };

  const handleEventFindProducto = (item) => {
    const code = item?.codigo || "";
    const famCode = (item?.familia?.chrCodigoFamilia || "").trim();
    const famDesc = item?.familia?.vchDescripcion || "";
    props.handleInputChangeDescripcion({ target: { value: code } });
    setDescripcion("");
    dispatch({
      type: actionType.LOAD_FILTER,
      displayFilter: false,
      listaFilter: [],
    });
    history.push(`/detalle/${encodeURIComponent(famCode)}/${encodeURIComponent(famDesc)}/${code}`);
  };

  const handleFindListProducto = async (_chrCodigoProducto) => {
    clearTimeout(timerRef.current);
    if (_chrCodigoProducto.length >= 3) {
      const listaFamilia = Array.isArray(marcaSelect?.listFamilia) ? marcaSelect.listFamilia : [];
      const rpt = await findProductosFilterInput({
        chrCodigoProducto: _chrCodigoProducto,
        listaFamilia,
      });
      const list = [];
      if (rpt.status === HttpStatus.HttpStatus_OK) {
        const json = await rpt.json();
        if (json.response.status === SUCCESS_SERVER.SUCCES_SERVER_OK) {
          for (let i = 0; i < json.listaProductos.length; i++) {
            const objProd = json.listaProductos[i];
            list.push({
              codigo: objProd.chrCodigoProducto,
              descripcion: objProd.vchDescripcion,
              familia: objProd.familia,
            });
          }
          dispatch({
            type: actionType.LOAD_FILTER,
            listaFilter: list,
            displayFilter: list.length > 0,
          });
        }
        if (json.response.status === SUCCESS_SERVER.SUCCES_SERVER_INFO) {
          dispatch({
            type: actionType.ERROR,
            server: { error: "", success: SUCCESS_SERVER.SUCCES_SERVER_INFO },
          });
        }
      } else {
        dispatch({
          type: actionType.ERROR,
          server: { error: "", success: SUCCESS_SERVER.SUCCES_SERVER_ERROR },
        });
      }
    } else {
      dispatch({
        type: actionType.DISPLAY_FILTER,
        displayFilter: false,
      });
    }

    timerRef.current = setTimeout(() => {
      dispatch({
        type: actionType.DISPLAY_FILTER,
        displayFilter: false,
      });
      setDescripcion("");
    }, 60000);
  };

  const badgeValue = state.cantidad > 99 ? "99+" : state.cantidad;
  const cartLink = state.cantidad >= 1 ? "/carrito" : "/shop";
  const handleBrandEnter = () => {
    if (!isTouch) setBrandOpen(true);
  };
  const handleBrandLeave = () => {
    if (!isTouch) setBrandOpen(false);
  };
  const handleBrandToggle = () => setBrandOpen((v) => !v);
  return (
    <header
      ref={headerRef}
      className={`nl-header nl-header--app ${inLanding ? "" : "nl-header--app-plain"}`}
    >
      <nav className="nl-nav">
        <Link className="nl-brand" to="/" aria-label="Ir al inicio">
          <img src={MOTRIX_LOGO} alt="Motrix" className="nl-brand__logo nl-brand__logo--muted" />
        </Link>

        <form
          action="#buscar"
          className="nl-search"
          role="search"
          aria-label="Busqueda"
          onSubmit={(e) => e.preventDefault()}
        >
          <div className="nl-search__control">
            <input
              type="search"
              name="q"
              id="q"
              placeholder="Buscar palabras clave"
              className="nl-search__input"
              value={descripcion}
              onChange={handleInputChangeDescripcion}
              onKeyDown={handleOnKeyDown}
            />
            <span className="nl-search__icon">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" width="20" height="20">
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="1.5"
                  d="M21 21l-4.35-4.35M10.5 18a7.5 7.5 0 1 1 0-15 7.5 7.5 0 0 1 0 15Z"
                />
              </svg>
            </span>
            <button type="button" className="sr-only" onClick={handleClickBuscarProductos}>
              Buscar
            </button>
            <div className={`nl-search__suggestions ${state.displayFilter ? "is-visible" : ""}`}>
              {state.listaFilter.map((item) => (
                <button
                  type="button"
                  key={item.codigo}
                  className="nl-search__result"
                  onClick={() => handleEventFindProducto(item)}
                >
                  <span className="nl-search__result-code">{item.codigo}</span>
                  <span className="nl-search__result-desc">{item.descripcion}</span>
                </button>
              ))}
            </div>
          </div>
        </form>

        <div className="nl-brand-switch" onMouseEnter={handleBrandEnter} onMouseLeave={handleBrandLeave}>
          <button
            type="button"
            className="nl-brand-switch__btn"
            onClick={handleBrandToggle}
          >
            <img
              src={buildLogoSrc()}
              alt={currentBrandOption?.label || "Marca"}
              className={`nl-brand__logo ${isMiniSelected ? "nl-brand__logo--white" : ""}`}
            />
            <span className="nl-brand-switch__label">{currentBrandOption?.label || "Marca"}</span>
          </button>
          {brandOpen && brandOptions.length > 0 && (
            <div className="nl-brand-switch__menu">
              {brandOptions.map((option) => (
                <button
                  type="button"
                  key={option.key}
                  className="nl-brand-switch__option"
                  onClick={() => handleSelectBrand(option)}
                >
                  <img src={option.logo} alt={option.label} className="nl-brand__logo" />
                  <span>{option.label}</span>
                </button>
              ))}
            </div>
          )}
        </div>

        <div className="nl-actions">
          <div className="nl-actions__user">
            {isLogged ? (
              <div className="nl-menu">
                <button className="nl-icon-btn" aria-haspopup="true" aria-expanded="false" aria-label="Menu de usuario">
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" width="28" height="28">
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="1.5"
                      d="M15.75 9a3.75 3.75 0 1 1-7.5 0 3.75 3.75 0 0 1 7.5 0Z"
                    />
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="1.5"
                      d="M4.5 20.25a8.25 8.25 0 1 1 15 0v.75H4.5v-.75Z"
                    />
                  </svg>
                </button>
                <div className="nl-menu__list">
                  <div className="nl-menu__items">
                    <Link to="/dashboard" className="nl-menu__item">
                      Mi cuenta
                    </Link>
                    <Link to="/dashboard" className="nl-menu__item">
                      Mis pedidos
                    </Link>
                    <button type="button" className="nl-menu__item nl-menu__item--action" onClick={props.handleLogout}>
                      Cerrar sesion
                    </button>
                  </div>
                </div>
              </div>
            ) : (
              <Link className="nl-icon-btn" to="/loginCliente" aria-label="Iniciar sesion">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" width="28" height="28">
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="1.5"
                    d="M15.75 9a3.75 3.75 0 1 1-7.5 0 3.75 3.75 0 0 1 7.5 0Z"
                  />
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="1.5"
                    d="M4.5 20.25a8.25 8.25 0 1 1 15 0v.75H4.5v-.75Z"
                  />
                </svg>
              </Link>
            )}
            {isLogged && <span className="nl-user__name">{nombre}</span>}
          </div>

          <Link to={cartLink} className="nl-icon-btn nl-cart" aria-label="Ir al carrito">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" width="28" height="28">
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="1.5"
                d="M2.25 3h1.386a1.5 1.5 0 0 1 1.447 1.106L6.39 7.5h11.11a1.5 1.5 0 0 1 1.46 1.851l-1.2 4.5a1.5 1.5 0 0 1-1.46 1.149H8.25m0 0L6.75 7.5m1.5 7.5L6 18.75m12-3.75a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3Zm-9.75 1.5a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3Z"
              />
            </svg>
            <span className="nl-badge">{badgeValue}</span>
          </Link>
        </div>
      </nav>
    </header>
  );
}

export default NewFilterMarcasHeader;
